// src/components/FilterDropdown.tsx

import React, { useState, useCallback } from 'react';
import { BaseDropdown } from './BaseDropdown';
import { FilterDropdownProps, DropdownOption } from '../types/Dropdown';

export const FilterDropdown: React.FC<FilterDropdownProps> = ({
    options,
    selectedFilters,
    onFilterChange,
    filterType,
    disabled = false,
    className = '',
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleToggleFilter = useCallback((option: DropdownOption) => {
        const isSelected = selectedFilters.includes(option.value);
        if (isSelected) {
            onFilterChange(selectedFilters.filter(filter => filter !== option.value));
        } else {
            onFilterChange([...selectedFilters, option.value]);
        }
    }, [selectedFilters, onFilterChange]);

    const isOptionSelected = (option: DropdownOption): boolean => {
        return selectedFilters.some(filter => filter === option.value);
    };

    const getDisplayText = () => {
        if (selectedFilters.length === 0) {
            return `Modify ${filterType} filters`;
        }
        return `${selectedFilters.length} ${filterType} ${selectedFilters.length === 1 ? 'group' : 'groups'} hidden`;
    };

    const toggleContent = (
        <span>{getDisplayText()}</span>
    );

    const menuContent = (
        <>
            {options.map((option, index) => (
                <label key={`${option.value || 'undefined'}-${index}`} className="checkbox-label">
                    <input
                        type="checkbox"
                        checked={!isOptionSelected(option)}
                        onChange={() => handleToggleFilter(option)}
                    />
                    {option.label}
                </label>
            ))}
        </>
    );

    return (
        <BaseDropdown
            toggleContent={toggleContent}
            menuContent={menuContent}
            disabled={disabled || options.length === 0}
            className={className}
            forceOpen={isOpen}
            onOpenChange={setIsOpen}
        />
    );
};